import api from "../utils/api";
import {
  LOGOUT
} from "./types";

export const search = ({ page = 0, size = 10, order = "name", direction = "asc", search = null }) => async (dispatch) => {
    try {
        const res = await api.get(`/courts/p/${page}/s/${size}/o/${order}/${direction}/${search}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT,
        });
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/courts/i/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({
    uuid,
    parentUuid,
    name,
    citation,
    full,
    district,
    division,
    url,
    email,
    phone,
    chambers,
    fax,
    addressUuid,
    Address,
    pacer
}) => async (dispatch) => {
    try {
        const res = await api.post(`/courts`, {
            uuid,
            parentUuid,
            name,
            citation,
            full,
            district,
            division,
            url,
            email,
            phone,
            chambers,
            fax,
            addressUuid,
            Address,
            pacer
        });

        return res.data;
    } catch (error) {
        if (error?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }

        throw error;
    }
};
